import { usePlaybackCurrentTs } from '@app/core/playback/hooks/usePlayback';
import { useFragmentsViewCapture } from '@app/modules/fragments/hooks/useFragmentsViewCapture';
import { buildLoggerStreamUrl } from '@app/modules/logger/screens/stream/helpers/build-logger-stream-url';
import ShortcutIcon from '@mui/icons-material/Shortcut';
import { IconButton, Tooltip } from '@mui/material';
import { defineMessage, useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';

const goToStreamFromPlaybackMessage = defineMessage({
  id: 'fragments.view.metadata.goToStreamFromPlayback',
  defaultMessage: 'Ir al stream en el tiempo actual del reproductor',
});

type FragmentGoToStreamFromPlaybackActionProps = {
  stationSlug: string;
};

/**
 * Action button that opens logger stream at the current playback timestamp.
 * It is disabled when playback context or currentTs is unavailable.
 */
export function FragmentGoToStreamFromPlaybackAction({
  stationSlug,
}: FragmentGoToStreamFromPlaybackActionProps) {
  const { $t } = useIntl();
  const fragmentsCapture = useFragmentsViewCapture();
  const currentTs = usePlaybackCurrentTs();
  const loggerStreamUrl = buildLoggerStreamUrl(stationSlug, {
    cursor: currentTs,
  });
  const handleClick = () => {
    fragmentsCapture.goToStreamFromPlayback({
      stationSlug,
      currentTs,
    });
  };

  return (
    <Tooltip title={$t(goToStreamFromPlaybackMessage)} placement="top">
      <IconButton
        component={RouterLink}
        to={loggerStreamUrl}
        onClick={handleClick}
        size="small"
        sx={{ color: 'text.secondary' }}
        disabled={!currentTs}
      >
        <ShortcutIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}
